import { render, staticRenderFns } from "./bet-chip-selector.vue?vue&type=template&id=3aeffb08&scoped=true"
import script from "./bet-chip-selector.vue?vue&type=script&lang=js"
export * from "./bet-chip-selector.vue?vue&type=script&lang=js"
import style0 from "./bet-chip-selector.vue?vue&type=style&index=0&id=3aeffb08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeffb08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aeffb08')) {
      api.createRecord('3aeffb08', component.options)
    } else {
      api.reload('3aeffb08', component.options)
    }
    module.hot.accept("./bet-chip-selector.vue?vue&type=template&id=3aeffb08&scoped=true", function () {
      api.rerender('3aeffb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-chip-selector.vue"
export default component.exports